type CalculateGuestTreatPointsProps = {
    price: number;
    quantity: number;
    guestTreatPoints?: number;
};

export const calculateGuestTreatPoints = ({ price, quantity, guestTreatPoints }: CalculateGuestTreatPointsProps) => {
    if (!guestTreatPoints || guestTreatPoints <= 0) return null;

    const totalPrice = price * quantity;

    return Math.trunc(totalPrice * guestTreatPoints).toString();
};
